import React, { useDebugValue, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  Row,
  Col,
  Modal,
  Divider,
  Button,
  Input,
  Dropdown,
  Breadcrumb,
  message,
} from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import '../../css/regimen.scss'
import { Redirect, useHistory, useLocation, useParams } from 'react-router'
import _, { isEmpty } from 'lodash'
import FeedbackEditCard from './feedback.edit.card'
import {
  addForm,
  getDeafultFeedSchedule,
  getFeedbackForms,
  patientForms,
  getPatientFeedSchedule,
  editFeedSchedule,
} from '../../store/action/feedback.action'
import {
  addCustomPatient,
  setNewPatient,
} from '../../store/action/patient.action'
import AddForm from './addForm'
import { constants } from '../../constants'
import PatientForm from '../patient/patient.form'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import moment from 'moment'
import { getHelp, pages } from '../../tutorials'

const EditFeedbackForm = (props) => {
  const location = useLocation()
  var history = useHistory()
  const params = useParams()
  var [editpage, setEditPage] = useState(
    window.location.pathname.includes('questionnaireschedule')
  )
  var [isEdited, setIsEdited] = useState(false)
  var [hide, setHide] = useState(false)
  const [open, setOpen] = useState(false)
  var showConfirmBox = (msg) => {
    Modal.confirm({
      title: 'Are you sure you want to leave this page?',
      icon: <ExclamationCircleOutlined />,
      content: msg,
      okText: 'Yes',
      cancelText: 'No',
      onOk: () => {
        handleback()
      },
    })
  }

  useEffect(() => {
    ;(async () => {
     props.setNewPatient(location.state?.patient)
      var res = false
      if (editpage)
        res = await props.getPatientFeedSchedule(
          props.patient?._id ? props.patient?._id : params.id
        )
      if (!editpage)
        props.getDeafultFeedSchedule({
          type: location.state.patient.surgery.type,
          customer: props.customer?._id,
        })
      props.getFeedbackForms(props.customer?._id)
    })()
    getHelp(pages.FEEDSCHED)
  }, [])

  const PatientCreatedBox = (devlen) => {
    Modal.confirm({
      title:
        devlen > 0 ? (
          <div>
            <b>{`${devlen} devices ordered for the new patient ${_.upperFirst(props.newPatient?.firstname)} ${_.upperFirst(props.newPatient?.lastname)}. `}</b>
          </div>
        ) : (
          'Patient created Successfully'
        ),
      icon: <ExclamationCircleOutlined />,
      content: devlen > 0 ? constants.MESSAGE.ORDER_PLACED : '',
      okText: 'Ok',
      cancelButtonProps: { hidden: 'true' },
    })
  }

  var handleNext = async () => {
    if (!Array.isArray(props.feedbackforms) || props.feedbackforms.length <= 0) {
      //message.error('Add atleast one form')
      //return;
    }
    var response = null
    if (editpage) {
      response = await props.editFeedSchedule(
        props.patient._id || params.id,
        props.feedbackforms
      )
      if (response) history.push(`/patient/${props.patient._id || params.id}`)
    } else {
      response = await props.addPatient(
        {
          ...props.newPatient,
          careplan: props.assignedPlan._id,
          include_regimens: props.assignedPlan.include_regimens,
        },
        props.assignedDevices[0] ? props.assignedDevices : [],
        props.exercises[0] ? props.exercises : [],
        props.feedbackforms
      )
      if (response) {
        PatientCreatedBox(props.assignedDevices?.length)
        history.push('/patient')
      }
    }
  }

  var handleback = () => {
    editpage
      ? history.push('/patient/' + location.state?.patient._id)
      : props.assignedPlan.include_regimens
        ? // history.push({
          //     pathname: "/patient/add/regimens",
          //     state: {patient: (Object.values(props.newPatient).length>0)? props.newPatient : location?.state?.patient
          //     }
          // })

          history.push({
            pathname: '/patient/add/schedule',
            state: {
              patient: props.newPatient,
              regimens: props.assignedRegs,
              assignedPlan: props.assignedPlan,
              assignedDevices: props.assignedDevices,
              exercises: props.exercises,
            },
          })
        : history.push({
            pathname: '/patient/add/devices',
            state: {
              patient:
                Object.values(props.newPatient).length > 0
                  ? props.newPatient
                  : location?.state?.patient,
              devices: props.devices,
              assignedPlan: props.assignedPlan,
              assignedDevices: props.assignedDevices,
            },
          })
  }
  var handleRemove = (id) => {
    var newList = props.feedbackforms?.filter((i, index) => index != id)
    props.patientForms(newList)
  }

  var applyAllFeed = (e) => {
    var newList = props.feedbackforms?.map((i, index) => {
      return {
      ...i,
      enddate: e.enddate,
      schedule: e.schedule,
      scheduletype: e.scheduletype,
      startdate: e.startdate,
      weekdays: e.weekdays,
      skiponsurgerydate:e.skiponsurgerydate || false
    }})
    props.patientForms(newList)
  }

  var applyAndSkipToAllFeed = (e) => {
    let newList = [...props.feedbackforms]
    newList[e?.index] = e
     newList = newList.map((i, index) => {
      return {
        ...i,
        skiponsurgerydate: true
      }
    })
    props.patientForms(newList)
  }

  var editform = (form) => {
    var newList = [...props.feedbackforms]
    newList[form?.index] = form

    props.patientForms(newList)
  }

  var renderActions = () => {
    return (
      <Row hidden={hide} style={{ paddingTop: '15px', alignItems: 'center' }}>
        <Col className='exerciseCol divide' flex={'25%'}>
          <Row justify='start'>
            <AddForm
              surgerydate={editpage ? props.patient?.surgery?.date : props.newPatient?.surgery?.date}
              handleRowSelect={props.addForm}
              forms={props.forms}
            />
          </Row>
        </Col>
        <Col className='exerciseColCenter divide' flex={'25%'}></Col>
        <Col className='exerciseCol divide' flex={'50%'}>
          <Row justify='end' gutter={40}>
            <Col>
              <Button
                onClick={() =>
                  editpage
                    ? isEdited
                      ? showConfirmBox(
                          'Your changes will be lost if you go back.'
                        )
                      : handleback()
                    : showConfirmBox(
                        'Your changes will be lost if you go back.'
                      )
                }
                className={'nextBtn'}
              >
                BACK
              </Button>
            </Col>
            <Col>
              <Button
                id={'saverpatient'}
                onClick={handleNext}
                disabled={editpage ? (isEdited ? false : true) : false}
                className={'nextBtn'}
              >
                {editpage ? 'SAVE' : 'CREATE'}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    )
  }

  var renderForms = () => {
    return props.feedbackforms
      ? props.feedbackforms.map((i, index) => {
          var form = _.find(props.forms, { _id: i.formid })
          return (
            <FeedbackEditCard
              setOpen={() => setOpen(form)}
              isEdited={() => setIsEdited(true)}
              surgerydate={editpage ? props.patient?.surgery?.date : props.newPatient?.surgery?.date}
              editform={editform}
              patient={location.state?.patient}
              addForm={props.addForm}
              handleRemove={handleRemove}
              form={{ ...i, ...form, index: index }}
              hideButton={setHide}
              hide={hide}
              editpage={editpage}
              applyAllFeed={applyAllFeed}
              applyAndSkipToAllFeed={applyAndSkipToAllFeed}
            />
          )
        })
      : null
  }

  var addForm = (i) => {
    var form = _.find(props.forms, { _id: i.formid })
  }
  var s = (d) => alert(d)

  return (
    <Col className='patientAddContainer'>
      {editpage && (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to='/patient'>Patients</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Questionnaire</Breadcrumb.Item>
        </Breadcrumb>
      )}
      {!location.state?.patient?.age && !props.newPatient && (
        <Redirect to='/patient/add/info' />
      )}
      <Row align='middle' className='headerRow divide scheduleHeaderCont'>
        <Row align='middle' className='headerRow divide scheduleHeaderCont'>
          <Col className='headerText scheduleHeader'>
            QUESTIONNAIRE SCHEDULE ( {_.upperFirst(props.newPatient?.firstname)}{' '}
            {_.upperFirst(props.newPatient?.lastname)} -{' '}
            <span
              style={{ fontSize: '17px' }}
            >{` Surgery Date: ${moment(props.newPatient?.surgery?.date).format('MM/DD/YYYY')}`}</span>
            )
          </Col>
        </Row>
      </Row>
      <Row className='exerciseRow'>
        <Col flex={'auto'}>{renderActions()}</Col>
      </Row>

      <Col flex={'auto'}>
        <Row
          style={{
            backgroundColor: '#f0f0f0',
            fontSize: '18px',
            padding: '24px',
          }}
        >
          <Col flex={'20%'}>
            <Row className='' justify='center'>
              FORM
            </Row>
          </Col>
          <Col flex={'60%'}>
            <Row className='' justify='center'>
              SCHEDULE
            </Row>
          </Col>
          <Col flex={'20%'}>
            <Row style={{ paddingLeft: 0 }} justify='center'>
              ACTIONS
            </Row>
          </Col>
        </Row>
      </Col>
      <Row className='regContainer regFeedContainer'>
        <Col id={'feedschedview'} flex={'auto'} className='formBody'>
          {renderForms()}
        </Col>
      </Row>
      <Divider style={{ marginTop: 0 }} />
      <Row className='exerciseRow'>
        <Col flex={'auto'}>{renderActions()}</Col>
      </Row>
      <Modal
        className={'formModal'}
        destroyOnClose={true}
        visible={open}
        footer={false}
        width={'70%'}
        onCancel={() => setOpen(false)}
      >
        {open && <PatientForm form={open} close={() => setOpen(false)} />}
      </Modal>
    </Col>
  )
}

EditFeedbackForm.propTypes = {
  company: PropTypes.object,
}

const mapStateToProps = (state) => {
  return {
    company: state.profile.company,
    newPatient: state.patient.newpatient,
    devices: state.device.devices,
    assignedPlan: state.device.assignedPlan,
    assignedDevices: state.device.assignedDevices,
    feedbackforms: state.feedback.patientforms,
    forms: state.feedback.forms,
    customer: state.profile.customer,
    exercises: state.schedule.exercises,
    patient: state.patient.patient,
    assignedRegs: state.regimen.assignedRegs,
    isLoading: state.profile.isLoading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addForm: (form) => dispatch(addForm(form)),
    getDeafultFeedSchedule: (input) => dispatch(getDeafultFeedSchedule(input)),
    getFeedbackForms: (customerid) => dispatch(getFeedbackForms(customerid)),
    patientForms: (forms) => dispatch(patientForms(forms)),
    addPatient: (patient, devices, exercises, feedback) =>
      dispatch(addCustomPatient({ patient, devices, exercises, feedback })),
    getPatientFeedSchedule: (id) => dispatch(getPatientFeedSchedule(id)),
    editFeedSchedule: (patientid, feedback) =>
      dispatch(editFeedSchedule({ patientid, feedback })),
    setNewPatient: (patient) => dispatch(setNewPatient(patient)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditFeedbackForm)
